import React from 'react';
import FlagIcon from '@mui/icons-material/Flag';
import { Chip, ChipProps } from '@mui/material';
import { DealActivityEventPriority } from '@trnsact/trnsact-shared-types';

interface Props {
  priority: DealActivityEventPriority;
}

const PRIORITY_CONFIG: Record<DealActivityEventPriority, { label: string; color: ChipProps['color'] }> = {
  [DealActivityEventPriority.High]: { label: 'High', color: 'error' },
  [DealActivityEventPriority.Medium]: { label: 'Medium', color: 'warning' },
  [DealActivityEventPriority.Low]: { label: 'Low', color: 'success' },
};

export const PriorityCell = ({ priority }: Props) => {
  const { label, color } = PRIORITY_CONFIG[priority] ?? { label: priority, color: 'default' };

  return <Chip size="small" variant="outlined" color={color} icon={<FlagIcon fontSize="small" />} label={label} />;
};
